import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import StoreSetupStep1Screen from '../screens/auth/StoreSetupStep1Screen';
import StoreSetupStep2Screen from '../screens/auth/StoreSetupStep2Screen';

const Stack = createNativeStackNavigator();

const StoreSetupNavigator = () => {
  return (
    <Stack.Navigator screenOptions={{headerShown: false}}>
      <Stack.Screen name="StoreSetupStep1" component={StoreSetupStep1Screen} />
      <Stack.Screen name="StoreSetupStep2" component={StoreSetupStep2Screen} />
    </Stack.Navigator>
  );
};

export default StoreSetupNavigator;
